import AppLayout from "../../../components/AppLayout/AppLayout";

export default function DutySlipDetail({ slip}) {
  const inputStyle = {
    width: "100%", padding: "10px 12px", border: "1px solid #d0c8f0",
    borderRadius: 8, fontSize: 13, color: "#333", background: "#f9f9f9",
    boxSizing: "border-box",
  };

  const expenses = slip?.expenses ?? [
  {
    date: "12 Feb 2025",
    time: "01:03 pm",
    leadId: "54563",
    amount: "₹ 500",
    paymentMode: "Petty Cash",
    remark: "Lorem Ipsum is simply dummy text...",
    file: "1010002.pdf",
  },
  {
    date: "12 Feb 2025",
    time: "11:03 am",
    leadId: "54563",
    amount: "₹ 350",
    paymentMode: "Bank",
    remark: "Lorem Ipsum is simply dummy text...",
    file: "IMG10002.jpeg",
  }
];

  return (
    <AppLayout>
         <div style={{ minHeight: "100vh", background: "#f7f7f7" }}>

      {/* Header */}

      {/* Breadcrumb */}
      <div style={{ background: "#fff", padding: "8px 14px", borderBottom: "0.5px solid #eee", display: "flex", gap: 6 }}>
        <span style={{ fontSize: 12, color: "#888" }}>Home</span>
        <span style={{ fontSize: 12, color: "#aaa" }}>›</span>
        <span style={{ fontSize: 12, color: "#888" }}>Duty Slip</span>
      </div>

      <div style={{ padding: 14, display: "flex", flexDirection: "column", gap: 12 }}>

        {/* Task */}
        <div>
          <label style={{ fontSize: 11, color: "#888", display: "block", marginBottom: 4 }}>Task</label>
          <input style={inputStyle} value={slip?.task ?? "Airport Drop"} readOnly />
        </div>

        {/* Task Description */}
        <div>
          <label style={{ fontSize: 11, color: "#888", display: "block", marginBottom: 4 }}>Task Description</label>
          <textarea
            readOnly
            value={slip?.description ?? "...."}
            style={{ ...inputStyle, resize: "none", minHeight: 70 }}
          />
        </div>

        {/* Lead Info Card */}
        <div style={{ background: "#fff", border: "0.5px solid #e0d8f5", borderRadius: 10, overflow: "hidden" }}>

          {/* Lead ID + Relocation Date */}
          <div style={{ padding: "10px 14px", borderBottom: "0.5px solid #eee", display: "flex", justifyContent: "space-between" }}>
            <span style={{ fontSize: 12, color: "#e05c8a", fontWeight: 500 }}>
              LEAD ID : {slip?.leadId ?? "54563"}
            </span>
            <span style={{ fontSize: 12, color: "#534AB7", fontWeight: 500 }}>
              Relocation Date : {slip?.relocationDate ?? "01 Jan 2024"}
            </span>
          </div>

          {/* From → To */}
          <div style={{
            padding: "10px 14px", background: "#f0eeff",
            display: "flex", justifyContent: "space-between", alignItems: "center",
          }}>
            <div>
              <div style={{ fontSize: 10, color: "#888", marginBottom: 2 }}>From</div>
              <div style={{ fontSize: 14, fontWeight: 500, color: "#534AB7" }}>{slip?.from ?? "INDIA"}</div>
            </div>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#b0a8e0" strokeWidth="1.5">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
            <div style={{ textAlign: "right" }}>
              <div style={{ fontSize: 10, color: "#888", marginBottom: 2 }}>To</div>
              <div style={{ fontSize: 14, fontWeight: 500, color: "#534AB7" }}>{slip?.to ?? "UAE"}</div>
            </div>
          </div>

          {/* Customer Details */}
          <div style={{ padding: "12px 14px", borderBottom: "0.5px solid #eee" }}>
            <SectionTitle bold="CUSTOMER" light="DETAILS" />
            <DetailRow label="Name"            value={slip?.customerName    ?? "Dinesh Patidar"} />
            <DetailRow label="Contact No."     value={slip?.contact         ?? "+91 **********"} />
            <DetailRow label="Alt Contact No." value={slip?.altContact      ?? "+91 **********"} />
            <DetailRow label="Address"         value={slip?.address         ?? "U55/11-A DLF Phase 3, Sector 24, Gurugram, Haryana"} />
          </div>

          {/* Pet Details */}
          <div style={{ padding: "12px 14px" }}>
            <SectionTitle bold="PET" light="DETAILS" />
            <DetailRow label="No. of Pet"       value={slip?.petCount  ?? "01"} />
            <DetailRow label="Pet Type"         value={slip?.petType   ?? "Dog"} />
            <DetailRow label="Pet Name & Breed" value={slip?.petBreed  ?? "Bruno | German Shepherd"} />
            <DetailRow label="Pet Age"          value={slip?.petAge    ?? "1 year 10 months"} />
            <DetailRow label="Crate Size"       value={slip?.crateSize ?? "32 inches"} />
          </div>
        </div>

        {/* Expense Details Header */}
        <div style={{ background: "#534AB7", borderRadius: 8, padding: "12px 14px" }}>
          <span style={{ color: "#fff", fontSize: 14, fontWeight: 500 }}>Expense Details</span>
        </div>

        {/* Expense Card */}
       <ExpenseCard expenses={expenses} />

      </div>
    </div>
    </AppLayout>
   
  );
}

function SectionTitle({ bold, light }) {
  return (
    <div style={{ fontSize: 12, fontWeight: 500, letterSpacing: "0.5px", marginBottom: 10 }}>
      <span style={{ color: "#534AB7" }}>{bold} </span>
      <span style={{ color: "#555" }}>{light}</span>
    </div>
  );
}

function DetailRow({ label, value }) {
  return (
    <div style={{ display: "flex", gap: 6, fontSize: 12, padding: "4px 0" }}>
      <span style={{ color: "#888", width: 120, flexShrink: 0 }}>{label}</span>
      <span style={{ color: "#333", flex: 1 }}>: {value}</span>
    </div>
  );
}

function ExpenseCard({ expenses }) {
  return (
    <>
      {expenses.map((item, index) => (
        <div
          key={index}
          style={{
            background: "#fff",
            border: "0.5px solid #e0d8f5",
            borderRadius: 10,
            overflow: "hidden",
            marginBottom: 12
          }}
        >
          {/* Date & Time */}
          <div
            style={{
              padding: "10px 14px",
              borderBottom: "0.5px solid #eee",
              display: "flex",
              justifyContent: "space-between"
            }}
          >
            <span style={{ fontSize: 12, color: "#ff6b6b" }}>
              Date: <strong>{item.date}</strong>
            </span>
            <span style={{ fontSize: 12, color: "#ff6b6b" }}>
              Time: <strong>{item.time}</strong>
            </span>
          </div>

          {/* Title */}
          <div
            style={{
              padding: "10px 14px",
              borderBottom: "0.5px solid #eee",
              background: "#f0eeff"
            }}
          >
            <span style={{ fontSize: 13, fontWeight: 500, color: "#534AB7" }}>
              {index + 1}- Item/Description
            </span>
          </div>

          {/* Details */}
          <div style={{ padding: "10px 14px" }}>
            <DetailRow label="Lead ID" value={item.leadId} />
            <DetailRow label="Amount" value={item.amount} />
            <DetailRow label="Payment Mode" value={item.paymentMode} />
            <DetailRow label="Remark" value={item.remark} />
          </div>

          {/* File */}
          <div style={{ padding: "10px 14px" }}>
            <div
              style={{
                border: "1px solid #d0c8f0",
                borderRadius: 8,
                padding: "8px 10px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
              }}
            >
              <span style={{ fontSize: 12 }}>{item.file}</span>
              <span style={{ cursor: "pointer" }}>🔗</span>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}